import CountryPageRenderer from '../components/CountryPageRenderer';
import uruguayData from '../data/country-pages/uruguay';

export default function UruguayCountryPage() {
  return <CountryPageRenderer data={uruguayData} />;
}
